module.exports = __webpack_public_path__ + "img/tcrb.474dbacc.svg";